export enum AccountSourceType {
  General = 1,
  ThriveScoreProvisional = 2,
  ThriveScoreComplete = 3,
  Mobile = 4,
  Store = 5,
  Admin = 6,
}
